import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppSettings } from '../helpers';
import { FilterModel } from '../models';
import { CustomerProfileEditModel } from '../models/customer';

@Injectable()
export class CustomerService {
    constructor(private http: HttpClient,
        private appSettings: AppSettings) { }

    getProfile() {
        return this.http.get(this.appSettings.ApiBaseUrl + '/api/customer/profile');
    }

    updateProfile(model: CustomerProfileEditModel) {
        return this.http.post(this.appSettings.ApiBaseUrl + '/api/customer/profile', model);
    }

    uploadProfileImage(profileImage: any) {
        const formData: FormData = new FormData();
        formData.append('profileImage', profileImage);
        return this.http.post(this.appSettings.ApiBaseUrl + '/api/customer/upload-profile-image',
            formData);
    }

    updateProfileImage(model: any) {
        return this.http.post(this.appSettings.ApiBaseUrl + '/api/customer/update-profile-image', model);
    }

    getCreators(model: FilterModel) {
        return this.http.post(this.appSettings.ApiBaseUrl + '/api/customer/get-creators', model);
    }
}



// WEBPACK FOOTER //
// ./src/services/customer.service.ts